module.exports = __webpack_public_path__ + "img/status_up.766e254c.png";